import { render, staticRenderFns } from "./ForumsMenu.vue?vue&type=template&id=786aaac6&"
import script from "./ForumsMenu.vue?vue&type=script&lang=js&"
export * from "./ForumsMenu.vue?vue&type=script&lang=js&"
import style0 from "./ForumsMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports